import { render, staticRenderFns } from "./mainCable.vue?vue&type=template&id=b55d501c&scoped=true"
import script from "./mainCable.vue?vue&type=script&lang=js"
export * from "./mainCable.vue?vue&type=script&lang=js"
import style0 from "./mainCable.vue?vue&type=style&index=0&id=b55d501c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55d501c",
  null
  
)

export default component.exports